export enum TextFieldTypes {
  INTEGER,
  FLOAT,
  TEXT,
}
